import { CrossSellingProductGroup } from "@tm/data/articles"
import { Article, ArticleListSortingMode, ArticleListType, CrossSellingModalType, ECrossSellingType } from "@tm/models"

export const CrossSellingTypeValues = [
    ECrossSellingType.alsoBoughtArticles,
    ECrossSellingType.alsoBoughtProductGroups,
    ECrossSellingType.recommendedProductGroups,
]

// MDM context values
export const CrossSellingContext: Record<ECrossSellingType, string> = {
    [ECrossSellingType.alsoBoughtArticles]: "Article",
    [ECrossSellingType.alsoBoughtProductGroups]: "ProductGroup",
    [ECrossSellingType.recommendedProductGroups]: "Recommended",
}

export type CrossSellingData = {
    referenceArticle: Article | undefined
    isLoading: boolean
    preventReset: boolean

    displayCustomerAlsoBoughtButton: boolean

    data: {
        [ECrossSellingType.alsoBoughtArticles]: Article[]
        [ECrossSellingType.alsoBoughtProductGroups]: CrossSellingProductGroup[]
        [ECrossSellingType.recommendedProductGroups]: CrossSellingProductGroup[]
    }
    chains: Record<ECrossSellingType, Article[][]>
}

export type CrossSellingProps = {
    newSearchLoaded?: boolean
    crossSellingModalType?: CrossSellingModalType | undefined
    sortChanged?: Record<number, ArticleListSortingMode | undefined>
    articlesCount?: number
    frontEndFilterChanged?: boolean
}

export type CrossSellingComponentProps = CrossSellingProps & {
    isAlternativeSearch?: boolean
    listType: ArticleListType
    sortChanged?: Record<number, ArticleListSortingMode | undefined>
    articlesCount?: number
    frontEndFilterChanged?: boolean
}

export type CrossSellingTabType = ECrossSellingType.alsoBoughtArticles | ECrossSellingType.recommendedProductGroups
